var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Star',{staticClass:"ItemStar",class:{ starred: _vm.starred },attrs:{"alt":_vm.starred ? 'Starred' : 'Unstarred'},on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }